<template>
  <el-dialog
    title="导出"
    :visible="visible"
    width="70%"
    :before-close="dialogClose"
  >
    <el-table :data="exportListData" border style="width: 100%">
      <el-table-column type="index" label="序号" width="50"> </el-table-column>
      <el-table-column label="描述">
        <template slot-scope="scope">
          {{ scope.row.title || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="导出开始时间">
        <template slot-scope="scope"
          >{{
            scope.row.beginTs ? formatDate(scope.row.beginTs, 1) : formatDate(scope.row.beginTs, 1)
          }}
        </template>
      </el-table-column>
      <el-table-column label="导出结束时间">
        <template slot-scope="scope">
          {{ scope.row.endTs === 0 ? '-' : formatDate(scope.row.endTs, 1) }}
        </template>
      </el-table-column>
      <el-table-column prop="state" label="导出状态">
        <template slot-scope="scope">{{ stateMap[scope.row.state] }}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
            <el-button
              :disabled="!scope.row.downloadUrl"
              @click="downLoadFile(scope.row.downloadUrl)"
              type="text"
              size="small"
            >
              下载结果</el-button
            >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align:right;"
      background
      @current-change="currentChange"
      :current-page.sync="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next"
      :total="total"
    >
    </el-pagination>
  </el-dialog>
</template>

<script>
import utils from '@/utils';
import { getExportList } from '@/api';
const stateMap = {
  0: '排队中',
  1: '处理中',
  2: '已完成',
  3: '异常失败',
};
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      stateMap,
      exportListData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
    };
  },
  mounted() {
    // this.getExportList();
  },
  watch: {
    visible(val) {
      if (val) {
        this.getExportList();
      }
    }
  },
  methods: {
    formatDate: utils.formatDate,
    getExportList() {
      const param = {
        page: this.currentPage,
        pageSize: this.pageSize,
      };
      getExportList(param).then(res => {
        console.log('2222', res);
        if (res.errno === 0) {
          this.exportListData = res.data.data;
          this.total = res.data.total;
        }
      });
    },
    downLoadBtn(url) {
      location.href = url;
    },
    currentChange(val) {
      this.currentPage = val;
      this.getExportList();
    },
    dialogClose() {
      window._setGlobalState_({ downloadVisible: false });
    },
    downLoadFile(url) {
      location.href = url;
    },
  },
};
</script>

<style scoped>
</style>
